function HomeController() {}

function HomeLeadController($scope) {}

function HomeHighlightsController($scope) {}
function HomeHighlightItemController($scope, $attrs) {
    $scope.view = { which: $attrs.which };
}

function HomeInsightsController($scope) {}
function HomeInsightItemController($rootScope, $scope, $attrs, $element, $compile) {

    this.$postLink = function() {
        var $a = $('a', $element).first();

        var elm = null;
        if ($attrs.which === 'interview-guide') elm = '<svg-interview-guide></svg-interview-guide>';
        else if ($attrs.which === 'development-report') elm = '<svg-development-report></svg-development-report>';
        else if ($attrs.which === 'leadership-report') elm = '<svg-leadership-report></svg-leadership-report>';
        else if ($attrs.which === 'sales-report') elm = '<svg-sales-report></svg-sales-report>';
        else if ($attrs.which === 'coaching-report') elm = '<svg-coaching-report></svg-coaching-report>';
        else if ($attrs.which === 'custom-report') elm = '<svg-custom-report></svg-custom-report>';
        if (!elm) return;

        $a.prepend($compile(elm)($rootScope.$new()));
    };
}

function HomeTestDriveController($scope) {}

angular.module('app')
    .component('home', {
        transclude: true,
        controller: [HomeController],
        template: '<div class="home-content" ng-transclude></div>'
    })
    .component('homeLead', {
        transclude: true,
        controller: ['$scope', HomeLeadController],
        templateUrl: '/assets/built/app/components/home/homeLead.html'
    })
    .component('homeHighlights', {
        controller: ['$scope', HomeHighlightsController],
        transclude: {
            'header': '?homeHighlightsHeader',
            'items': '?homeHighlightsItems',
            'footer': '?homeHighlightsFooter'
        },
        template: '<div class="home-highlights-header" ng-transclude="header"></div><div class="home-highlights-items" ng-transclude="items"></div><div class="home-highlights-footer" ng-transclude="footer"></div>'
    })
    .component('homeHighlightItem', {
        transclude: true,
        controller: ['$scope', '$attrs', HomeHighlightItemController],
        templateUrl: '/assets/built/app/components/home/homeHighlightItem.html',
        bindings: {
            which: '@'
        }
    })
    .component('homeInsights', {
        controller: ['$scope', HomeInsightsController],
        transclude: {
            'header': '?homeInsightsHeader',
            'items': '?homeInsightsItems',
            'footer': '?homeInsightsFooter'
        },
        template: '<div class="home-insights-header" ng-transclude="header"></div><div class="home-insights-items" ng-transclude="items"></div><div class="home-insights-footer" ng-transclude="footer"></div>'
    })
    .component('homeInsightItem', {
        transclude: true,
        controller: ['$rootScope', '$scope', '$attrs', '$element', '$compile', HomeInsightItemController],
        templateUrl: '/assets/built/app/components/home/homeInsightItem.html',
        bindings: {
            which: '@'
        }
    })
    .component('homeTestDrive', {
        transclude: true,
        controller: ['$scope', HomeTestDriveController],
        templateUrl: '/assets/built/app/components/home/homeTestDrive.html'
    })
